import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import env from './../../../../environments/environment'
import appConstants from './../../../../constants/appConstants'
import CareerRequestModal from './../../../../components/modals/CareerRequestModal/CareerRequestModal.component'
import VideoPlayerModal from './../../../../components/VideoPlayerModal/VideoPlayerModal.component'
import UsertypeService from '../../../../shared/services/Usertype.service'
import { getWhiteLabelLogo } from './../../../../shared/utilities/whiteLabel.function'
import { getPhone, getEmail, getFirstName, getFullName } from './../../formatters'
import { getAgentLogo } from './../../branding'
import CoBrandLogo from './../CoBrandLogo/CoBrandLogo.component'
import { phoneToStorage, phoneToView } from './../../../../shared/formatters/telephone.formatter'

import './AgentHeader.component.scss'

const OPPORTUNITY_VIDEO_URL = 'https://player.vimeo.com/video/729389367',
  SHOWCASE_VIDEO_URL = 'https://vimeo.com/showcase/8843553',
  ENABLE_OPP_VIDEO = true,
  LOGO_IMG = `https://firebasestorage.googleapis.com/v0/b/${env.integrations.firebase.config.storageBucket}/o/static%2Flogos%2Flogo.usabg-amerilife-website.jpg?alt=media`,
  DRAWER_LOGO_IMG = `https://firebasestorage.googleapis.com/v0/b/${env.integrations.firebase.config.storageBucket}/o/static%2Flogos%2Flogo.usabg-amerilife-plain.md.jpg?alt=media`

const getLinkUrl = link => {
  let url =
    link?.url &&
    link.url.replace(/^(https:?\/\/(www\.)?)/i, 'https://www.').replace(/^(http:?\/\/(www\.)?)/i, 'http://www.')
  url = url && !/^((http|https):)|(\/\/)/i.test(url) ? `//${url}` : url
  return url ? url : ''
}

class AgentHeader extends Component {
  constructor(props) {
    super(props)

    this.state = {
      siteId: null,
      resourceLinks: [],
      drawerOpen: false,
      expanded: {},
      showOppVideo: false,
      careerModalIsOpen: false,
      phone: false,
    }
  }

  openDrawer = () => this.setState({ drawerOpen: true })
  closeDrawer = () => this.setState({ drawerOpen: false, expanded: {} })

  toggleExpanded = label =>
    this.setState(prev => ({
      expanded: { ...prev.expanded, [label]: !prev.expanded[label] },
    }))

  toggleOppVideo = evt => {
    if (evt) evt.preventDefault()
    this.setState(prev => ({ showOppVideo: !prev.showOppVideo }))
    return false
  }

  careerOpportunityVideo = extraClass => {
    const s_recruiting_url = this.props.subsiteData?.s_recruiting_url || false

    if (s_recruiting_url)
      return (
        <a className={extraClass} target='_BLANK' href={s_recruiting_url} rel='noopener noreferrer'>
          Opportunity Video
        </a>
      )

    return (
      <a className={extraClass} href='#opp-video' onClick={this.toggleOppVideo}>
        Opportunity Video
      </a>
    )
  }

  _setMenuLinks = resourceLinks => {
    resourceLinks = Array.isArray(resourceLinks) ? resourceLinks : []
    this.setState({
      siteId: parseInt(this.props.subsiteData.site_id),
      resourceLinks,
    })
  }

  _canEnroll = () => {
    const usertypeId = this.props.subsiteData?.usertype_id
    if (!usertypeId) return false
    return (
      UsertypeService.isA('recruiter-group', usertypeId) ||
      UsertypeService.isA('agency-owner', usertypeId) ||
      UsertypeService.isA('system-admin', usertypeId)
    )
  }

  componentDidMount() {
    this._setMenuLinks(this.props.subsiteData?.resource_links || [])
    this.setState({ phone: getPhone(this.props.subsiteData, phoneToStorage) })
  }

  componentDidUpdate() {
    if (this.props.subsiteData?.site_id && parseInt(this.props.subsiteData.site_id) !== parseInt(this.state.siteId))
      this._setMenuLinks(this.props.subsiteData?.resource_links || [])

    try {
      const phone = getPhone(this.props.subsiteData, phoneToStorage)
      if (phone !== this.state.phone) this.setState({ phone })
    } catch (ex) {}
  }

  renderQuoteCta(extraClass = '') {
    const { phone } = this.state
    const login = this.props.subsiteData?.u_login
    const href = phone ? `tel:${phone}` : login ? `/${login}/contact` : '#'
    return (
      <a className={`header-quote-cta ${extraClass}`} href={href}>
        <span>Call For A Quote</span>
      </a>
    )
  }

  // Shared career sub-items (used by both desktop dropdown + mobile drawer)
  renderCareerItems(linkClass) {
    const { subsiteData } = this.props
    const login = subsiteData?.u_login
    const isRbanville = `${login}`.trim().toLowerCase() === 'rbanville'

    return (
      <>
        {isRbanville ? (
          <li>
            <Link className={linkClass} to='#' onClick={() => this.setState({ careerModalIsOpen: true })}>
              Learn More
            </Link>
          </li>
        ) : (
          <></>
        )}
        {ENABLE_OPP_VIDEO ? (
          <li>
            {isRbanville ? (
              <a
                className={linkClass}
                target='_BLANK'
                href='https://careers.usabg.com/rbanville'
                rel='noopener noreferrer'
              >
                Opportunity Video
              </a>
            ) : (
              this.careerOpportunityVideo(linkClass)
            )}
          </li>
        ) : (
          <></>
        )}
        {appConstants?.enable_agent_testimonials ? (
          <li>
            <a className={linkClass} target='_BLANK' href={SHOWCASE_VIDEO_URL} rel='noopener noreferrer'>
              Agent Testimonials
            </a>
          </li>
        ) : (
          <></>
        )}
        {this._canEnroll() ? (
          <li>
            <a className={linkClass} href={login ? `/${login}/enroll` : '#'}>
              Enroll
            </a>
          </li>
        ) : (
          <></>
        )}
      </>
    )
  }

  render() {
    const { subsiteData } = this.props
    const { resourceLinks, drawerOpen, expanded } = this.state
    const login = subsiteData?.u_login
    const phone = this.state.phone
    const email = getEmail(subsiteData)
    const rxCardLink = `${subsiteData?.rx_card_link || ''}`.trim()
    const webConfLink = `${subsiteData?.s_web_confrence_link || ''}`.trim()
    const firstName = getFirstName(subsiteData)
    const webConfLabel = firstName ? `Web Conference with ${firstName}` : 'Web Conference'
    const hasResources = (resourceLinks && resourceLinks.length > 0) || webConfLink || rxCardLink
    const isWhiteLabel = `${subsiteData?.show_white_label}` === '1'
    const whiteLabelLogo = isWhiteLabel ? getWhiteLabelLogo(subsiteData?.white_label_logo) : false
    const agentLogo = getAgentLogo(subsiteData)
    const agentLogoAlt = getFullName(subsiteData) || 'Agency logo'
    const isResolved = this.props.isResolved !== false

    return (
      <header id='AgentHeaderComponent'>
        <div className='header-inner'>
          <Link to={login ? `/${login}` : '/'} className='header-brand'>
            {!isResolved ? (
              <span className='brand-logo-skeleton' />
            ) : whiteLabelLogo ? (
              <img alt='' src={whiteLabelLogo} style={{ maxHeight: '84px', width: 'auto' }} />
            ) : isWhiteLabel ? (
              <></>
            ) : agentLogo ? (
              <CoBrandLogo agentLogo={agentLogo} agentLogoAlt={agentLogoAlt} partnerLogo={DRAWER_LOGO_IMG} />
            ) : (
              <img alt='USA Benefits Group' src={LOGO_IMG} />
            )}
          </Link>

          {/* Desktop navigation */}
          <nav className='header-nav'>
            <ul>
              <li>
                <Link to={login ? `/${login}` : '/'}>Home</Link>
              </li>
              <li>
                <Link to={login ? `/${login}/products` : '#'}>Products</Link>
              </li>
              {hasResources ? (
                <li className='has-dropdown'>
                  <span className='dropdown-label'>Resources</span>
                  <ul className='dropdown'>
                    {webConfLink ? (
                      <li>
                        <a href={getLinkUrl({ url: webConfLink })} target='_BLANK' rel='noopener noreferrer'>
                          {webConfLabel}
                        </a>
                      </li>
                    ) : (
                      <></>
                    )}
                    {resourceLinks.map((link, i) => (
                      <li key={`asub-menu${i}`}>
                        <a href={getLinkUrl(link)} target='_BLANK' rel='noopener noreferrer'>
                          {link.displayname}
                        </a>
                      </li>
                    ))}
                    {rxCardLink ? (
                      <li>
                        <a href={getLinkUrl({ url: rxCardLink })} target='_BLANK' rel='noopener noreferrer'>
                          Rx Card
                        </a>
                      </li>
                    ) : (
                      <></>
                    )}
                  </ul>
                </li>
              ) : (
                <></>
              )}
              <li className='has-dropdown'>
                <span className='dropdown-label'>Careers</span>
                <ul className='dropdown'>{this.renderCareerItems()}</ul>
              </li>
              <li>
                <Link to={login ? `/${login}/contact` : '#'}>Get a Quote</Link>
              </li>
            </ul>
          </nav>

          {this.renderQuoteCta('header-quote-desktop')}

          {/* Hamburger (mobile/tablet) */}
          <div className='header-hamburger'>
            <button
              type='button'
              className='header-hamburger-btn'
              aria-label='Open navigation'
              aria-controls='subsite-drawer'
              aria-expanded={drawerOpen}
              onClick={this.openDrawer}
            >
              <svg width='30' height='30' viewBox='0 0 100 100'>
                <path
                  d='M3.6 10.8h92.8c2 0 3.6 1.6 3.6 3.6s-1.6 3.6-3.6 3.6H3.6C1.6 18 0 16.4 0 14.4s1.6-3.6 3.6-3.6zm0 35.7h92.8c2 0 3.6 1.6 3.6 3.6s-1.6 3.6-3.6 3.6H3.6C1.6 53.7 0 52.1 0 50.1s1.6-3.6 3.6-3.6zm0 35.7h92.8c2 0 3.6 1.6 3.6 3.6s-1.6 3.6-3.6 3.6H3.6C1.6 89.4 0 87.8 0 85.8s1.6-3.6 3.6-3.6z'
                  fill='currentColor'
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Slide-in drawer */}
        {drawerOpen ? <div className='header-drawer-overlay' onClick={this.closeDrawer} /> : <></>}
        <div id='subsite-drawer' className={`header-drawer${drawerOpen ? ' is-open' : ''}`}>
          <div className='header-drawer-header'>
            <button
              type='button'
              className='header-drawer-close'
              aria-label='Close navigation'
              onClick={this.closeDrawer}
            >
              <svg width='24' height='24' viewBox='0 0 100 100'>
                <path
                  d='M82 87.9c1.6 1.6 4.3 1.6 5.9 0 1.6-1.6 1.6-4.3 0-5.9L55.5 49.6l32.4-32.4c1.6-1.6 1.6-4.3 0-5.9-1.6-1.6-4.3-1.6-5.9 0L49.6 43.7 17.2 11.3c-1.6-1.6-4.3-1.6-5.9 0-1.6 1.6-1.6 4.3 0 5.9l32.4 32.4-32.4 32.4c-1.6 1.6-1.6 4.3 0 5.9 1.6 1.6 4.3 1.6 5.9 0l32.4-32.4L82 87.9z'
                  fill='currentColor'
                />
              </svg>
            </button>
          </div>

          <nav className='header-drawer-nav'>
            <ul>
              <li>
                <Link className='header-drawer-link' to={login ? `/${login}` : '/'} onClick={this.closeDrawer}>
                  Home
                </Link>
              </li>
              <li>
                <Link className='header-drawer-link' to={login ? `/${login}/products` : '#'} onClick={this.closeDrawer}>
                  Products
                </Link>
              </li>

              {hasResources ? (
                <li>
                  <button
                    type='button'
                    className='header-drawer-toggle'
                    aria-expanded={!!expanded.Resources}
                    onClick={() => this.toggleExpanded('Resources')}
                  >
                    <span>Resources</span>
                    <span className={`header-drawer-chevron${expanded.Resources ? ' is-open' : ''}`}>
                      <svg width='12' height='8' viewBox='0 0 10 6'>
                        <path
                          d='M1 1l4 4 4-4'
                          stroke='currentColor'
                          strokeWidth='1.5'
                          fill='none'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>
                    </span>
                  </button>
                  <ul className={`header-drawer-subnav${expanded.Resources ? ' is-open' : ''}`}>
                    {webConfLink ? (
                      <li>
                        <a
                          className='header-drawer-link'
                          href={getLinkUrl({ url: webConfLink })}
                          target='_BLANK'
                          rel='noopener noreferrer'
                        >
                          {webConfLabel}
                        </a>
                      </li>
                    ) : (
                      <></>
                    )}
                    {resourceLinks.map((link, i) => (
                      <li key={`dsub-menu${i}`}>
                        <a
                          className='header-drawer-link'
                          href={getLinkUrl(link)}
                          target='_BLANK'
                          rel='noopener noreferrer'
                        >
                          {link.displayname}
                        </a>
                      </li>
                    ))}
                    {rxCardLink ? (
                      <li>
                        <a
                          className='header-drawer-link'
                          href={getLinkUrl({ url: rxCardLink })}
                          target='_BLANK'
                          rel='noopener noreferrer'
                        >
                          Rx Card
                        </a>
                      </li>
                    ) : (
                      <></>
                    )}
                  </ul>
                </li>
              ) : (
                <></>
              )}

              <li>
                <button
                  type='button'
                  className='header-drawer-toggle'
                  aria-expanded={!!expanded.Careers}
                  onClick={() => this.toggleExpanded('Careers')}
                >
                  <span>Careers</span>
                  <span className={`header-drawer-chevron${expanded.Careers ? ' is-open' : ''}`}>
                    <svg width='12' height='8' viewBox='0 0 10 6'>
                      <path
                        d='M1 1l4 4 4-4'
                        stroke='currentColor'
                        strokeWidth='1.5'
                        fill='none'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                    </svg>
                  </span>
                </button>
                <ul className={`header-drawer-subnav${expanded.Careers ? ' is-open' : ''}`}>
                  {this.renderCareerItems('header-drawer-link')}
                </ul>
              </li>

              <li>
                <Link className='header-drawer-link' to={login ? `/${login}/contact` : '#'} onClick={this.closeDrawer}>
                  Get a Quote
                </Link>
              </li>
            </ul>
          </nav>

          <div className='header-drawer-footer'>
            <Link to={login ? `/${login}` : '/'} className='header-drawer-footer-logo' onClick={this.closeDrawer}>
              {!isResolved ? (
                <span className='brand-logo-skeleton' />
              ) : whiteLabelLogo ? (
                <img alt='' src={whiteLabelLogo} />
              ) : isWhiteLabel ? (
                <></>
              ) : agentLogo ? (
                <CoBrandLogo
                  agentLogo={agentLogo}
                  agentLogoAlt={agentLogoAlt}
                  partnerLogo={DRAWER_LOGO_IMG}
                  layout='stacked'
                />
              ) : (
                <img alt='USA Benefits Group' src={DRAWER_LOGO_IMG} />
              )}
            </Link>
            <div className='header-drawer-contact'>
              {phone ? (
                <span>
                  Phone: <a href={`tel:${phone}`}>{phoneToView(phone)}</a>
                </span>
              ) : (
                <></>
              )}
              {email ? (
                <span>
                  Email: <a href={`mailto:${email}`}>{email}</a>
                </span>
              ) : (
                <></>
              )}
            </div>
            {this.renderQuoteCta('header-quote-drawer')}
          </div>
        </div>

        <CareerRequestModal
          isOpen={this.state.careerModalIsOpen}
          onClose={() => this.setState({ careerModalIsOpen: false })}
        />
        <VideoPlayerModal
          open={this.state.showOppVideo}
          onClose={() => this.setState({ showOppVideo: false })}
          videoUrl={OPPORTUNITY_VIDEO_URL}
          videoTitle={'USABG Opportunity Video'}
        />
      </header>
    )
  }
}

export default AgentHeader
